"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../../context");

var _layout = require("../../layout");

var _constants = require("../html/constants");

var _constants2 = require("../constants");

var _html = require("../html");

var _interfaces = require("../interfaces");

var _TableHeaderButton = _interopRequireDefault(require("./TableHeaderButton"));

var _constants3 = require("./constants");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TableHeader = function TableHeader(_ref) {
  var columns = _ref.columns,
      hasActionColumn = _ref.hasActionColumn,
      actionHeader = _ref.actionHeader,
      actionColumnIndex = _ref.actionColumnIndex,
      onSort = _ref.onSort,
      spacing = _ref.spacing,
      sortDirection = _ref.sortDirection,
      activeSortId = _ref.activeSortId,
      isStriped = _ref.isStriped,
      hasStickyHeader = _ref.hasStickyHeader,
      _ref$ascendingTitleTe = _ref.ascendingTitleText,
      ascendingTitleText = _ref$ascendingTitleTe === void 0 ? _constants2.defaultProps.ascendingTitleText : _ref$ascendingTitleTe,
      _ref$descendingTitleT = _ref.descendingTitleText,
      descendingTitleText = _ref$descendingTitleT === void 0 ? _constants2.defaultProps.descendingTitleText : _ref$descendingTitleT;

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var actionCellWidth = _constants3.ACTION_BUTTON_WIDTH + 2 * selectors.space(_constants.CELL_SPACING_HORIZONTAL);
  var baseColumns = columns.map(function (_ref2, index) {
    var header = _ref2.header,
        textAlign = _ref2.textAlign,
        width = _ref2.width,
        sortId = _ref2.sortId,
        _ref2$headerCellType = _ref2.headerCellType,
        headerCellType = _ref2$headerCellType === void 0 ? _constants2.defaultColumnAttributes.headerCellType : _ref2$headerCellType;
    var isCurrentSortedColumn = activeSortId === sortId;
    var isSortable = sortId !== undefined && !!onSort;
    var isCellTypeHeader = headerCellType === _interfaces.CellType.Header;
    var Cell = isCellTypeHeader ? _html.ThElement : _html.TdElement;
    var onSortClick = sortId !== undefined && !!onSort ? function () {
      return onSort({
        sortId: sortId,
        sortDirection: sortDirection === _interfaces.SortDirection.Ascending ? _interfaces.SortDirection.Descending : _interfaces.SortDirection.Ascending
      });
    } : undefined;
    var columnSortDirection = isCurrentSortedColumn ? sortDirection : _interfaces.SortDirection.None;
    var justifyContent = textAlign === 'right' ? 'flex-end' : textAlign === 'center' ? 'center' : 'flex-start';
    var headerTypeCellProps = isCellTypeHeader ? {
      scope: 'col',
      isSortable: isSortable,
      'aria-sort': isSortable ? columnSortDirection : undefined
    } : {};
    var titleText = sortDirection === _interfaces.SortDirection.Ascending ? descendingTitleText : ascendingTitleText;
    return (0, _core.jsx)(Cell, (0, _extends2.default)({
      key: index,
      textAlign: textAlign,
      spacing: spacing,
      width: width,
      isStriped: isStriped,
      hasStickyHeader: isCellTypeHeader ? hasStickyHeader : undefined
    }, headerTypeCellProps), isSortable ? (0, _core.jsx)(_TableHeaderButton.default, {
      spacing: spacing,
      sortDirection: columnSortDirection,
      titleText: titleText,
      onClick: onSortClick,
      justifyContent: justifyContent
    }, header) : (0, _core.jsx)(_layout.Row, {
      gridGap: "S200",
      alignItems: "center",
      justifyContent: justifyContent
    }, header));
  });
  var isActionCustomPosition = actionColumnIndex || actionColumnIndex === 0; // Slicing the header columns to insert the actionHeader at any index.

  return (0, _core.jsx)(_html.TheadElement, null, (0, _core.jsx)(_html.TrElement, null, isActionCustomPosition ? baseColumns.slice(0, actionColumnIndex) : baseColumns, hasActionColumn && (0, _core.jsx)(_html.ThElement, {
    scope: "col",
    spacing: spacing,
    isStriped: isStriped,
    hasStickyHeader: hasStickyHeader,
    width: actionCellWidth
  }, actionHeader), isActionCustomPosition ? baseColumns.slice(actionColumnIndex) : null));
};

TableHeader.displayName = 'TableHeader';
var _default = TableHeader;
exports.default = _default;